import { IconClear } from 'braid-design-system';

import Action from './Action';

interface ExpireActionProps {
  onClick: () => void;
}

export const ExpireAction = ({ onClick }: ExpireActionProps) => (
  <Action Icon={IconClear} action="Remove" onClick={onClick} />
);
